window.o_global = window.o_global || {};

/**
 * Queue all registered functions to be handled as window.onload event handler.
 *
 * @param {Function} func   Function to be queued to window.onload.
 */
o_global.onloadHandler = o_global.onloadHandler || function(func) {
        "use strict";

        var loadFunc = window.onload;

        if (typeof window.onload !== "function") {
            window.onload = func;
        } else {
            window.onload = function() {
                if (!!loadFunc) {
                    loadFunc();
                }

                func();
            };
        }
    };
